import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { SiteHeader } from '../../components/layout/SiteHeader';
import { Button } from '../../components/ui/Button';
import { Input, Label } from '../../components/ui/Input';
import { useAuthStore } from '../../state/authStore';
import { t } from '../../i18n';
import './auth-page.css';

export default function RegisterPage() {
  const navigate = useNavigate();
  const register = useAuthStore((s) => s.register);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [offline, setOffline] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password.length < 8) {
      setError(t('auth.errors.weakPassword'));
      return;
    }
    setSubmitting(true);
    setError(null);
    setOffline(false);
    const result = await register(name, email, password);
    setSubmitting(false);
    if (result.ok) {
      navigate('/projecten');
    } else {
      setOffline(result.offline);
      setError(
        result.offline ? t('auth.login.offlineNotice') : result.message || t('auth.errors.generic'),
      );
    }
  };

  return (
    <div className="page-shell">
      <SiteHeader />
      <div className="centered-page">
        <div className="auth-card">
          <h1>{t('auth.register.title')}</h1>
          <p className="auth-card-subtitle">{t('auth.register.subtitle')}</p>

          {error ? (
            <div className={offline ? 'auth-notice' : 'auth-error'}>
              <span>{error}</span>
              {offline ? (
                <Button variant="secondary" size="sm" onClick={() => navigate('/projecten')}>
                  {t('auth.login.continueAsGuest')}
                </Button>
              ) : null}
            </div>
          ) : null}

          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="field-group">
              <Label htmlFor="name">{t('auth.register.name')}</Label>
              <Input id="name" required value={name} onChange={(e) => setName(e.target.value)} />
            </div>
            <div className="field-group">
              <Label htmlFor="email">{t('auth.register.email')}</Label>
              <Input
                id="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="field-group">
              <Label htmlFor="password">{t('auth.register.password')}</Label>
              <Input
                id="password"
                type="password"
                autoComplete="new-password"
                required
                minLength={8}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <span className="field-hint">{t('auth.register.passwordHint')}</span>
            </div>
            <Button type="submit" variant="primary" size="lg" disabled={submitting}>
              {submitting ? t('common.loading') : t('auth.register.submit')}
            </Button>
          </form>

          <div className="auth-footer">
            <span>
              {t('auth.register.haveAccount')}{' '}
              <Link to="/login">{t('auth.register.loginCta')}</Link>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
